import React, { useState, useCallback, useEffect } from "react";
import CommonFormLabel from "../../components/formLabel";
import ValidationFeedback from "../../components/validationFeedback";
import CommonButton from "../../components/commonButton";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import { Toast, Form, Row, Col, Card } from "react-bootstrap";
import { Formik } from "formik";
import { faqSchema } from "../../schema/validationSchemas";
import { getFaqDetail, updateFaq } from "./faqSlice";
import Editor from "../../components/commonEditor";
import TextArea from "../../components/commonTextArea";

export default function Edit() {
  const { id: faqId } = useParams();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const [faq, setFaq] = useState(null);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const currentPage = params.get("page") || 1;

  const fetchFaqDetails = useCallback(async () => {
    setLoading(true);
    try {
      const result = await dispatch(getFaqDetail(faqId));
      const faqData = result.payload.data;

      setFaq(faqData);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching faq:", error);
    } finally {
      setLoading(false);
    }
  }, [dispatch, faqId, setLoading]);

  useEffect(() => {
    setFaq(null);
    if (faqId) {
      // fetchCategories();
      fetchFaqDetails();
    }
  }, [faqId, fetchFaqDetails]);

  const handleCancel = () => {
    setFaq(null);
    navigate(
      `/faqs?page=${currentPage}&order_by=sequence&order=asc`
    );
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    setIsSubmitting(true);

    const dataToSubmit = {
      ...values,
      id: faqId,
      sequence: parseInt(values.sequence),
      _method: "PUT",
    };

    const formData = new FormData();

    Object.entries(dataToSubmit).forEach(([key, value]) => {
      formData.append(key, value);
    });

    await dispatch(updateFaq(formData))
      .then((res) => {
        if (res.payload && res.payload.success) {
          localStorage.setItem(
            "faq_notify_message",
            res.payload.message
          );
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
          setFaq(null);
          navigate(
            `/faqs?page=${currentPage}&order_by=sequence&order=asc`
          );
        } else {
          setErrors(res.payload.data);
          setSnackbarMessage(
            res.payload.message || "Failed to update faq!"
          );
          setSnackbarVariant("danger");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
        }
      })
      .catch((error) => {
        setSnackbarMessage("Failed to update faq!");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
        setSubmitting(false);
        setIsSubmitting(false);
      });
  };

  if (!faq)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "60vh" }}
      >
        <h2>Loading Faq Details...</h2>
      </div>
    );

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>
      {faq && (
        <Formik
          initialValues={{
            // parent_faq_id: faq?.parent_faq_id || "",
            question: faq.question || "",
            answer: faq.answer || "",
            sequence: faq.sequence || "",
          }}
          validationSchema={faqSchema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            touched,
            handleChange,
            handleSubmit,
            values,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit} encType="multipart/form-data">
              {/* <div className="mb-4"> */}
              {/* <h3 className="mb-4 text-center">Edit Faq</h3> */}

              <Card className="bg-white p-4 rounded-2 shadow-sm mb-4">
                <h4 className="mb-4 d-flex justify-content-center">Basic</h4>
                <Row>
                <Col md={12} className="">
                    <CommonFormLabel htmlFor="question" title="Question" />
                     <TextArea
                        id="question"
                        name="question"
                        placeholder="Enter Question"
                        value={values.question}
                        onChange={handleChange}
                        className={`shadow-none ${
                          errors?.question && touched.question
                            ? "error"
                            : "correct"
                        }`}
                        rows={4}
                      />
                    {touched.question && errors?.question && (
                      <ValidationFeedback title={errors?.question} />
                    )}
                  </Col>
                </Row>

                <div className="mb-4">
                  <CommonFormLabel htmlFor="answer" title="Answer" />
                  <Editor
                    value={values.answer}
                    onChange={(content) => setFieldValue("answer", content)}
                  />
                  {touched.answer && errors?.answer && (
                    <ValidationFeedback title={errors?.answer} />
                  )}
                </div>

                {/* <Col md={6} className="mb-4">
                  <CommonFormLabel htmlFor="sequence" title="Sequence" />
                  <Input
                    id="sequence"
                    name="sequence"
                    type="number"
                    value={values.sequence}
                    min="1"
                    placeholder="Enter Sequence"
                    onChange={handleChange}
                    className={`shadow-none ${
                      errors?.sequence && touched.sequence ? "error" : "correct"
                    }`}
                  />
                  {touched.sequence && errors?.sequence && (
                    <ValidationFeedback title={errors?.sequence} />
                  )}
                </Col> */}
              </Card>

              <div className="d-flex align-items-center justify-content-end gap-3 common-popup-btn">
                <CommonButton
                  title={isSubmitting ? "Updating..." : "Update"}
                  type="submit"
                  disabled={isSubmitting}
                  className="btn-primary primary-shadow"
                />
                <CommonButton
                  title="Cancel"
                  onClick={handleCancel}
                  className="btn-muted"
                />
              </div>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
}
